import type { MultiSelectValueProps } from '@mantine/core';
import { createStyles, Group } from '@mantine/core';
import type { ReactNode } from 'react';
import { IconButton } from '../Buttons';
import { Text } from '../Text';

const useValueComponentStyles = createStyles((theme) => ({
	container: {
		borderRadius: 1000,
		backgroundColor: theme.other.getColor('surface/primary/active'),
		flexWrap: 'nowrap',
		padding: `${theme.spacing['4xs']} ${theme.spacing['2xs']}`,
	},
	removeIcon: {
		margin: `-2px -2px -2px 0`,
	},
	displayIcon: {
		margin: `-2px 0 -2px -4px`,
	},
}));

export default function ValueComponent({
	label,
	icon,
	onRemove,
}: {
	label: ReactNode;
	icon?: ReactNode;
} & MultiSelectValueProps) {
	const hasIcon = !!icon;

	const { classes } = useValueComponentStyles();

	return (
		<Group spacing={0} className={classes.container}>
			{hasIcon && <div className={classes.displayIcon}>{icon}</div>}
			<Text size="xs">{label}</Text>
			<IconButton
				variant="tertiary"
				iconName="x"
				onClick={onRemove}
				className={classes.removeIcon}
				size="xs"
			/>
		</Group>
	);
}
